import { styled } from "@mui/material/styles";
import { NavLink } from "react-router";

import {
  CATEGORY_CHIP_TEXT_INSET_X,
  INSIGHT_META_TYPOGRAPHY,
} from "~/components/UI/CategoryChip/CategoryChip.styles";

/** Width of `#` at INSIGHT_META_TYPOGRAPHY — hangs left of tag name. */
const TAG_HASH_OFFSET = "0.55em";

export const TagLink = styled(NavLink)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "baseline",
  textDecoration: "none",
  paddingLeft: `${CATEGORY_CHIP_TEXT_INSET_X}px`,
  color: theme.palette.text.secondary,
}));

export const TagHash = styled("span")(() => ({
  ...INSIGHT_META_TYPOGRAPHY,
  marginLeft: `calc(-1 * ${TAG_HASH_OFFSET})`,
}));

export const TagLabel = styled("span")(() => ({
  ...INSIGHT_META_TYPOGRAPHY,
}));
